import React from "react";

const InputGroup = ({
    type,
    name,
    disabled,
    value,
    onChangeHandler,
    placeholder,
    icon,
    isFormSubmitted,
    onBlur = null,
    label = "",
    wrapperClassNames = "",
    customClassNames = "",
    inputClassNames = "",
    error,
}) => {
    const renderIcon = () => {
        if (icon)
            return (
                <>
                    <i className={`fas fa-${icon} fa-xs icon-input`}></i>
                    <span className="input-separat-line"></span>
                </>
            );
    };

    return (
        <div className={`flex items-baseline gap-2 ${wrapperClassNames}`}>
            <label>{label}</label>
            <div
                className={`input-group ${customClassNames} ${
                    error?.[name] && isFormSubmitted
                        ? "invalid-warning-input"
                        : ""
                }`}
            >
                {renderIcon()}
                <input
                    type={type}
                    name={name}
                    className={`input-element ${icon && "input-icon-padding"} ${
                        disabled && "disabled"
                    } ${inputClassNames}`}
                    value={value || ""}
                    onChange={onChangeHandler}
                    onBlur={onBlur || null}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};

export default InputGroup;
